import { IconShieldCheck } from '@iwoca/icons';
import { Link } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import BankGrid from './BankGrid';
import styles from './BankSelectionModal.module.css';
import { TOnlineBank } from '../OpenBanking.types';
import TrueLayerShareableLink from '../TrueLayerShareableLink/TrueLayerShareableLink';

const BankListViewUK = ({
  banks,
  onSearch,
  searchTerm,
  onBankSelect,
  ableToShareLink,
}: {
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBankSelect: (bank: TOnlineBank) => void;
  banks: TOnlineBank[];
  searchTerm: string;
  ableToShareLink: boolean;
}) => (
  <>
    {ableToShareLink && (
      <>
        <TrueLayerShareableLink noBankLogin />
        <hr className={styles.divider} />
      </>
    )}
    <div className={styles.bankListDescription}>
      <div className={styles.bankListHeader}>
        <h3 className={styles.bankListTitle}>
          <Trans>How does it work?</Trans>
        </h3>
      </div>
      <Trans>
        Securely share your bank account’s data. Simply choose your bank below
        and then log in through your bank’s portal when prompted.
      </Trans>
      <div className={styles.bankGradeContainer}>
        <IconShieldCheck className={styles.bankGradeIcon} />
        <span>
          <Trans>Bank-grade encryption</Trans>
        </span>
      </div>
    </div>
    <BankGrid
      banks={banks}
      onSearch={onSearch}
      searchTerm={searchTerm}
      onBankSelect={onBankSelect}
    />
    <div
      className={styles.trueLayerFooter}
      data-testid="true-layer-modal-footer"
    >
      <p>
        <small>
          We’re{' '}
          <Link
            data-testid="fca-regulated-link"
            href="https://www.fca.org.uk/about/what-we-do/the-fca"
            target="_blank"
            rel="noopener noreferrer"
          >
            FCA registered
          </Link>{' '}
          which allows us to offer Open Banking
        </small>
      </p>
    </div>
  </>
);

export default BankListViewUK;
